module.exports = __webpack_public_path__ + "img/newheadersearch.3b2ca088.svg";